import type { Metadata } from 'next';

export const appDetails = {
  mymorize: {
    title: 'Mymorize',
    description: 'Deine moderne Lernplattform',
  },
  mympu: {
    title: 'myMPU',
    description: 'Deine Plattform zur MPU Vorbereitung',
  },
} as const;

export function getAppDetail() {
  // Needs to be available on build time
  const slug = process.env.NEXT_PUBLIC_THEME_SLUG as keyof typeof appDetails;
  return appDetails[slug] || appDetails.mymorize;
}

export async function generateMetadata({
  params,
}: {
  params: { courseSlug: string; tabId: string };
}): Promise<Metadata> {
  const courseTitle = decodeURIComponent(params.courseSlug); // or fetch it
  const tabLabel = decodeURIComponent(params.tabId); // or map to label

  return {
    title: `${courseTitle} – ${tabLabel}`,
  };
}
